import * as SERVICE from "@/common/services/common-request-service";
import {NOTIFICATION_TYPE} from "@/common/utils/constants";
import store from "../store/index.js";
import router from "@/common/router";
import Vue from "vue";
import msal from "vue-msal";

export function getNotificationsForProjectsWaitingForApproval() {
	SERVICE.getUserProjectIdsWaitingForApproval(store.getters.getUser.id)
		.then((response) => {
			let params = {
				collection: Array.from(response),
				message: "Your project is waiting for your approval.",
				type: NOTIFICATION_TYPE.INFO
			}
			store.dispatch('addNotifications', params)
		})
}

export function getNotificationsForPublishedProjects() {
	SERVICE.getPublishedProjectsId(store.getters.getUser.id)
		.then((response) => {
			let params = {
				collection: Array.from(response),
				message: `Your project has been published.`,
				type: NOTIFICATION_TYPE.SUCCESS
			}
			store.dispatch('addNotifications', params);
		})
}

export function redirectAfterLogin() {
	let redirectUrl = localStorage.getItem('redirectToUrlAfterLogin');
	if (redirectUrl && redirectUrl.trim() !== '') {
		router.push(redirectUrl)
		localStorage.removeItem('redirectToUrlAfterLogin');
		console.warn(`Removed redirect path after login: ${redirectUrl}`)
	} else {
		router.push('/landing');
	}
}

export function logout() {
	store.dispatch('signout')
		.then(() => {
			let isSso = localStorage.getItem('isSso');
			if (isSso && isSso === 'true') {
				signoutSsoUser();
			}
			localStorage.removeItem('isSso');
			localStorage.removeItem('NewUpdateRefresh');
			localStorage.removeItem('jwt');
			localStorage.removeItem('attemptedLoginWith');
			removeUserIdFromHotjar();
			router.push('/login');
		});
}

function removeUserIdFromHotjar() {
	if (window.hj) {
		window.hj('identify', null, {});
	} else {
		console.error("User id was not nullified in Hotjar")
	}
}

function signoutSsoUser() {
	if (Vue.prototype.$msal === undefined) {
		createMsalInstance();
	}
	Vue.prototype.$msal.signOut()
}

function createMsalInstance() {
	let graphScope = [];
	let scopes = [];
	const ssoLoginType = {akka: "Akka", adecco: "Adecco"}
	let attemptedLoginWith = localStorage.getItem('attemptedLoginWith');

	if (attemptedLoginWith === ssoLoginType.adecco) {
		scopes = [
			"user.read",
			"profile",
			"mailboxsettings.read",
			"calendars.readwrite",
		];
		graphScope = ["user.read"];
	} else {
		scopes = [
			"user.read",
			"User.Read",
			"profile",
			"email"
		];
		graphScope = ["user.read", "User.Read"];
	}

	let redirectUrl = window.location.origin;

	Vue.use(msal, {
		auth: {
			clientId: process.env.VUE_APP_CLIENT_ID,
			tenantId: process.env.VUE_APP_TENANT_ID,
			redirectUri: `${redirectUrl}/login`,
			postLogoutRedirectUri: process.env.VUE_APP_POST_LOGOUT_URL,
			scopes: graphScope,
			autoRefreshToken: true,
		},
		cache: {
			cacheLocation: "localStorage",
			storeAuthStateInCookie: false,
		},
		request: {
			scopes: scopes,
		},
		graph: {
			callAfterInit: false,
			endpoints: {
				profile: "/me",
				// photo: { url: '/me/photo/$value', responseType: 'blob', force: true }
			},
		},
	});
}
